/**
 * Created with IntelliJ IDEA.
 * User: danielr
 * Date: 4/9/14
 * Time: 8:22 AM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var template = require("manager-templates/data-sources/attributes/notSupportedScraperTemplate.tmpl");

    var ScraperNotSupportedView = {};
    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {
        ScraperNotSupportedView = Marionette.ItemView.extend({
            template: template,
            initialize: function (options) {
                LEManager.logger.debug("ScraperNotSupportedView:initialize");

            },

            onClose: function() {
                LEManager.logger.debug("ScraperNotSupportedView:onClose");
            }
        });
    });
    return ScraperNotSupportedView;
});

